import React, { useState } from 'react';
import { Button, ButtonVariants } from '../../Atoms/Button';
import LoginModal from '../login-modal';
import { LOGIN_MODAL_CARDS } from '../login-modal/constants';
import { handleTrack } from '../../../utils/tracker';

const CustomNavbarCTA: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
    handleTrack({
      action: 'click',
      label: 'navbar_button_new_Get Started',
    });
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        variant={ButtonVariants.pinkfilled}
        rounded="sm"
        className="w-full text-base font-bold px-6 py-3 sm:px-2 sm:py-2 border-blue-350 border-[1.5px] border-solid"
        onClick={handleOpenModal}
      >
        Get Started
      </Button>
      <LoginModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        modalCards={LOGIN_MODAL_CARDS}
        foldLocation="navbar"
      />
    </>
  );
};

export default CustomNavbarCTA;
